const GET_CURRENT_DAY_TRANSACTION_ANALYTICS =
  "/backoffice/analytics/currentDay/transactions";
const GET_HISTORIC_TRANSACTION_ANALYTICS =
  "/backoffice/analytics/historical/transactions";
const GET_CURRENT_DAY_DISPUTE_ANALYTICS =
  "/backoffice/analytics/currentDay/dispute";
const GET_HISTORIC_DISPUTE_ANALYTICS =
  "/backoffice/analytics/historical/dispute";

export const DASHBOARD_ANALYTICS_ROUTES = {
  GET_CURRENT_DAY_DISPUTE_ANALYTICS,
  GET_CURRENT_DAY_TRANSACTION_ANALYTICS,
  GET_HISTORIC_DISPUTE_ANALYTICS,
  GET_HISTORIC_TRANSACTION_ANALYTICS,
};
